module.exports = __webpack_public_path__ + "img/crescent_moon.7b22deda.png";